<script lang="ts">
	import { quintOut } from "svelte/easing";
	import { fadeSlide } from "../../generic/scripts/animations";
	import { config } from "../scripts/stores";

	export let invalidParams: [string, string][] = [];
	export let alertType: "warning" | "danger" = "danger";
	export let title: string = "";
	export let paramsTitle: string = "";

	$: hasSomeParams = invalidParams.length > 0;
</script>

{#if $config.SHOW_INVALID_VARIANT && hasSomeParams}
	<div class="alert alert-{alertType}" role="alert" out:fadeSlide={{ easing: quintOut }}>
		<slot name="title">
			{#if title}
				<p class="fw-bold fs-6 m-0">{title}</p>
			{/if}
		</slot>
		<slot name="params">
			{#if paramsTitle}
				<span class="d-block fs-8 mb-2">{paramsTitle}</span>
			{/if}
			<div class="d-flex flex-wrap gap-2">
				{#each invalidParams as [param, value]}
					<span class="badge bg-secondary">{param}: {value}</span>
				{/each}
			</div>
		</slot>
	</div>
{/if}
